module.exports = __webpack_public_path__ + "img/Choice.230d772b.gif";